import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';
import { useState } from 'react';

export const DownloadSheet = ({
  administrationBox,
  courseAssessmentId,
  handleDownloadData,
}: any) => {
  const [selectAdmNo, setAdmNo] = useState(1);
  const [loading, setLoading] = useState(false);
  return (
    <>
      <Grid container gap={2} className='my-1 pl-2'>
        <h2 className='font-medium p-1 mb-2 rounded-sm'>
          Select an individual administration:
        </h2>

        <FormControl sx={{ minWidth: 220 }} size='small'>
          <Select
            value={selectAdmNo}
            onChange={(event: any) => {
              const {
                target: { value },
              } = event;
              setAdmNo(value);
            }}
            size='small'
          >
            {administrationBox?.map((item: any, index: number) => (
              <MenuItem key={index} value={item.administration_no}>
                <ListItemText primary={item.administration_no} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid component='h2' className='font-semibold  my-1 pl-2 rounded-sm'>
        <Button
          variant='outlined'
          onClick={async () => {
            if (typeof courseAssessmentId !== 'string') return;
            setLoading(true);
            const success = await handleDownloadData(
              courseAssessmentId,
              String(selectAdmNo)
            );

            setLoading(false);
          }}
          children={
            loading ? (
              <CircularProgress color='inherit' size={25} />
            ) : (
              'Download'
            )
          }
          sx={{ width: 150 }}
          disabled={loading}
          size='medium'
        />
      </Grid>
    </>
  );
};
